"use client";

import {
  Checkbox,
  Heading,
  Link,
  SearchField,
  Switch,
  Text,
} from "ui-components";

import { IEventsSearchParams } from "@/src/app/[locale]/(public)/events/page";
import { useNavigate } from "@/src/hooks/useNavigate";

import { SEARCH_FILTERS } from "../enums/search-filters.enum";

interface INewsListingHeaderProps {
  searchParams: IEventsSearchParams;
  isLoading: boolean;
}

export function EventsListingHeader({
  searchParams,
  isLoading,
}: Readonly<INewsListingHeaderProps>): JSX.Element {
  const { pushQueryParam } = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center flex-1 w-full mt-10 gap-4 lg:mt-4 lg:gap-[30px]">
      <div className="flex flex-col w-full gap-x-5 items-center justify-center">
        <Heading variant="h1">Events</Heading>
      </div>
      <div className="flex flex-col gap-y-5 w-full lg:w-[60rem]">
        <SearchField
          placeholder="Search with keywords, name of event, topic"
          size="xxl"
          value={searchParams[SEARCH_FILTERS.SEARCH] ?? ""}
          onChange={(term) => {
            pushQueryParam({
              key: SEARCH_FILTERS.SEARCH,
              value: term,
              shouldResetPage: true,
              scroll: false,
            });
          }}
          isLoading={isLoading}
        />
        <div className="flex justify-between flex-col lg:flex-row items-center gap-5">
          <div className="flex flex-col lg:flex-row gap-4">
            <Checkbox
              label="Show myGwork events"
              isSelected={
                searchParams[SEARCH_FILTERS.SHOW_MYGWORK_EVENTS] === "true"
              }
              onChange={(remoteValue) => {
                pushQueryParam({
                  key: SEARCH_FILTERS.SHOW_MYGWORK_EVENTS,
                  value: remoteValue ? "true" : "false",
                  shouldResetPage: true,
                  scroll: false,
                });
              }}
            />
            <Checkbox
              label="Show virtual events"
              isSelected={
                searchParams[SEARCH_FILTERS.SHOW_VIRTUAL_EVENTS] === "true"
              }
              onChange={(remoteValue) => {
                pushQueryParam({
                  key: SEARCH_FILTERS.SHOW_VIRTUAL_EVENTS,
                  value: remoteValue ? "true" : "false",
                  shouldResetPage: true,
                  scroll: false,
                });
              }}
            />
            <Checkbox
              label="Show in-person events"
              isSelected={
                searchParams[SEARCH_FILTERS.SHOW_IN_PERSON_EVENTS] === "true"
              }
              onChange={(remoteValue) => {
                pushQueryParam({
                  key: SEARCH_FILTERS.SHOW_IN_PERSON_EVENTS,
                  value: remoteValue ? "true" : "false",
                  shouldResetPage: true,
                  scroll: false,
                });
              }}
            />
          </div>
          <div className="flex items-center gap-x-5">
            <div className="flex items-center justify-center gap-x-2.5">
              <Text variant="small">Only Show Past Events</Text>
              <Switch
                size="sm"
                hideText
                defaultSelected={
                  searchParams[SEARCH_FILTERS.SHOW_PAST_EVENTS] === "true"
                }
                onChange={(isSelected) => {
                  pushQueryParam({
                    key: SEARCH_FILTERS.SHOW_PAST_EVENTS,
                    value: isSelected ? "true" : "false",
                    shouldResetPage: true,
                    scroll: false,
                  });
                }}
              />
            </div>
            <Link fontSize="sm" href="/events" className="ml-auto">
              Clear filters
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
